<template lang="pug">
  span(ref='text')
    slot
</template>
<script>
import Mark from 'mark.js'
import {mapGetters} from 'vuex'

export default {
  data () {
    return {
      mark: null
    }
  },
  mounted () {
    this.mark = new Mark(this.$refs.text)
    this.mark.unmark()
    this.mark.mark(this.searchObject.texts, {
      separateWordSearch: false
      // accuracy: 'exactly'
    })
  },
  computed: {
    ...mapGetters('search', [
      'searchText',
      'searchObject',
      'searchOpen'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// MarkText.vue?0ed2f91d